import { useQuery } from '@apollo/client';

import { GetInstoreAnalyticsTokenDocument } from 'src/gql/graphql';

// TODO: Verify this file can be deleted https://dutchie.atlassian.net/browse/ENG-47649
export type AnalyticsTokenResponse = {
  analyticsToken?: string;
  loading: boolean;
};

export function useGetAnalyticsToken(): AnalyticsTokenResponse {
  const { data, loading, error } = useQuery(GetInstoreAnalyticsTokenDocument);

  if (error) {
    console.error(error);

    return {
      analyticsToken: undefined,
      loading: false,
    };
  }

  return {
    analyticsToken: data?.getInstoreAnalyticsToken?.instoreAnalyticsTokenId,
    loading,
  };
}
